const STUDIO_MAIN_DATA = {
    "id": "studio_main",
    "category": "studio",
    "name": "Studio",
    "levels": [
        {
            "tileSize": 256,
            "size": 256,
            "fallbackOnly": true
        },
        {
            "tileSize": 512,
            "size": 512
        },
        {
            "tileSize": 512,
            "size": 1024
        },
        {
            "tileSize": 512,
            "size": 2048
        }
    ],
    "faceSize": 1920,
    "initialViewParameters": {
        "pitch": 0.03667625834346033,
        "yaw": -0.4223956984513606,
        "fov": 1.112832132700145
    },
    "linkHotspots": [
        {
            "yaw": -0.9616117905896306,
            "pitch": 0.040302836689672716,
            "rotation": 0,
            "target": "studio_tv",
            "category": "tvs",
            "pathname": "/studio/tvs/tv/OLED65G29LA",
            "targetCameraView": {
                "yaw": 0.1993592667127757,
                "pitch": 0.045656059969896745,
                "fov": 1
            },
            "targetCameraView2": {
                "yaw": 0,
                "pitch": 0.21538524537931089,
                "fov": 1
            }
        },
        {
            "yaw": 0.1731759899839851,
            "pitch": 0.07127169832721236,
            "rotation": 0,
            "target": "studio_fr",
            "category": "fridge",
            "pathname": "/studio/fridge/side_by_sides/GSXV90MCDE",
            "targetCameraView": {
                "yaw": 0.24285583787532872,
                "pitch": 0.05620696066291231,
                "fov": 1
            },
            "targetCameraView2": {
                "yaw": 0,
                "pitch": 0.25620696066291231,
                "fov": 1
            }
        },
        {
            "yaw": 3.0,
            "pitch": 0.7,
            "rotation": 0,
            "target": "studio_projector",
            "category": "it",
            "pathname": "/studio/it/beam_projector/HU715QW",
            "targetCameraView": {
                "yaw": -0.0071422242109075995,
                "pitch": 0.1553467231693677,
                "fov": 1
            },
            "targetCameraView2": {
                "yaw": -0.30276122450648373,
                "pitch": 0.07620233814263244,
                "fov": 1
            }
        },
        {
            "yaw": 3.13,
            "pitch": 0.56,
            "rotation": 0,
            "target": "studio_projector",
            "category": "portable_speakers",
            "pathname": "/studio/portable_speakers/portable_speaker/DXG7QBK",
            "targetCameraView": {
                "yaw": -0.0322143176234313,
                "pitch": 0.07620233814263244,
                "fov": 1
            },
            "targetCameraView2": {
                "yaw": -0.30276122450648373,
                "pitch": 0.07620233814263244,
                "fov": 1
            }
        },
        {
            "yaw": -1.566555166444175,
            "pitch": 0.2794985078687944,
            "rotation": 0,
            "arrow":true,
            "target": "studio_toilet",
            "category": "wm",
            "pathname": "/studio/wm/wm/F4WV709P2BA",
            "targetCameraView": {
                "yaw": 0.02704449235143791,
                "pitch": 0.06191195100668523,
                "fov": 1.45
            },
            "targetCameraView2": {
                "yaw": -0.5448200723351064,
                "pitch": 0.4816234939238875,
                "fov": 1.45
            }
        },
    ],
    "infoHotspots": [],
};
export default STUDIO_MAIN_DATA;
